import { render, staticRenderFns } from "./pack_configurator.vue?vue&type=template&id=4ca7891a&scoped=true&lang=html"
import script from "./pack_configurator.vue?vue&type=script&lang=js"
export * from "./pack_configurator.vue?vue&type=script&lang=js"
import style0 from "./pack_configurator.vue?vue&type=style&index=0&id=4ca7891a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7891a",
  null
  
)

export default component.exports